<!-- <header>
      <h2>Step {{ selectedIndex + 1 }}/{{ steps.length }}</h2>
    </header> -->
<div class="form" id="stepper" fxLayout="row wrap" (dblclick)="wow()">
    <div class="stepper" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <!-- <button class="example-nav-button" cdkStepperPrevious>&larr;</button> -->
                <!-- <div *ngFor="let step of steps; let i = index">
                    <button class="example-step" [class.example-active]="selectedIndex === i"
                        (click)="selectStepByIndex(i)">
                        Step {{ i + 1 }}
                    </button><br>
                </div> -->
                <button class="example-step" [class.example-active]="selectedIndex === 0"
                    (click)="selectStepByIndex(0)">
                    <div class="stepperButton">
                        <div fxFlex="3.2em">
                            <div class="circleBase type2">
                                <div class="circleBase type1">
                                    <i id="i1" class="flaticon-container"></i>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="label" class="btnLabel" fxFlex="auto">
                            <span id="step1">Container Information
                            </span>
                        </div>
                    </div>
                </button>
                <svg height="4rem" width="4rem" class="example-step"
                    [class.example-active]="selectedIndex === 1 || selectedIndex === 2 || selectedIndex === 3">
                    <line x1="1.89rem" y1="0" x2="1.89rem" y2="7rem" />
                </svg>
                <button class="example-step" [class.example-active]="selectedIndex === 1"
                    (click)="selectStepByIndex(1)">
                    <div class="stepperButton">
                        <div fxFlex="100">
                            <div class="circleBase type2">
                                <div class="circleBase type1">
                                    <i id="i2" class="flaticon-characteristic"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="label" class="btnLabel" fxFlex="auto">
                            <span id="step2">Physical Characteristics
                            </span>
                        </div>
                    </div>
                </button>
                <svg height="4rem" width="4rem" class="example-step"
                    [class.example-active]="selectedIndex === 3 || selectedIndex === 2">
                    <line x1="1.89rem" y1="0" x2="1.89rem" y2="7rem" />
                </svg>
                <button class="example-step" [class.example-active]="selectedIndex === 2"
                    (click)="selectStepByIndex(2)">
                    <div class="stepperButton">
                        <div fxFlex="100">
                            <div class="circleBase type2">
                                <div class="circleBase type1">
                                    <i id="i3" class="flaticon-paper"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="label" class="btnLabel" fxFlex="auto">
                            <span id="step3">Documents
                            </span>
                        </div>
                    </div>

                </button>
                <ng-container *ngIf="lifeCycleStep">
                    <svg height="4rem" width="4rem" class="example-step" [class.example-active]="selectedIndex === 3">
                        <line x1="1.89rem" y1="0" x2="1.89rem" y2="7rem" />
                    </svg>
                    <button class="example-step" [class.example-active]="selectedIndex === 3"
                        (click)="selectStepByIndex(3)">
                        <div class="stepperButton">
                            <div fxFlex="100">
                                <div class="circleBase type2">
                                    <div class="circleBase type1">
                                        <i id="i3" class="flaticon-life-cycle"></i>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="label" class="btnLabel" fxFlex="auto">
                                <span id="step3">Lifecycle Details
                                </span>
                            </div>
                        </div>

                    </button>
                </ng-container>
                <!-- <button class="example-nav-button" cdkStepperNext>&rarr;</button> -->
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div class="formContent" fxFlex="100">
    <mat-card>
        <mat-card-content>
            <div [ngTemplateOutlet]="selected ? selected.content : null"></div>
        </mat-card-content>
    </mat-card>
</div>